import { combineReducers } from 'redux'
import * as types from '../actions/reduxTypes'

function chefs(state = [], action = {}) {
 switch(action.type) {
    case types.SET_CHEFS:
      return action.chefs;
    default: return state;
  }
}

export default combineReducers({
  chefs,
})


// WEBPACK FOOTER //
// ./src/reducers/index.js